class HALEmbeddedMedia {
    constructor() {
        this.initialized = false;
        this.buttonSelector = '.hal-embedded-media-play';
        this.previewSelector = '.hal-embedded-media-preview';
        this.templateSelector = '.hal-embedded-media-embed';
        // media that starts playing once the visitor has asked for it
        this.autoplayHosts = ['youtube.com', 'youtube-nocookie.com', 'youtu.be', 'vimeo.com'];
    }

    init() {
        const _self = window.HAL?.EmbeddedMedia;

        // one listener on the document, so widgets rendered after this point
        // (e.g. while editing the page in the page builder) work as well
        if (_self.initialized) return;
        _self.initialized = true;

        document.addEventListener('click', (event) => {
            const button = event.target.closest(_self.buttonSelector);

            if (button) {
                _self.loadMedia(button);
            }
        });
    }

    // Replaces the thumbnail button with the embed code held in the template beside it
    loadMedia(button) {
        const _self = window.HAL?.EmbeddedMedia;
        const container = button.closest(_self.previewSelector);
        const template = container?.querySelector(_self.templateSelector);

        if (!template) return; // nothing to load, leave the thumbnail as it is

        const embed = template.content.cloneNode(true);
        const iframe = embed.querySelector('iframe');

        if (iframe) {
            _self.playOnLoad(iframe);
        }

        container.appendChild(embed);
        template.remove();
        button.remove();

        // the visitor asked for this media, so put them in it
        container.querySelector('iframe')?.focus();
    }

    // The visitor already pressed play, so ask the video to start rather than
    // making them press play a second time inside the player.
    playOnLoad(iframe) {
        const _self = window.HAL?.EmbeddedMedia;

        if (!iframe.src) return;

        let src = null;

        try {
            src = new URL(iframe.src, window.location.origin);
        } catch {
            // a src we can't read is left alone - the visitor can still press play in the player
            return;
        }

        if (_self.autoplayHosts.some(host => src.hostname === host || src.hostname.endsWith(`.${host}`))) {
            src.searchParams.set('autoplay', '1');
            iframe.src = src.toString();
        }
    }
}

if (typeof window.HAL !== 'undefined') {
    window.HAL.EmbeddedMedia = new HALEmbeddedMedia();
}
